<template>
  <div
    class="cell-hide-show"
    :class="[!isLongText && 'cell-hide-show_center']"
    :ref="`cell-hide-show_${row._id}`"
    :style="{height: `${isShow ? longHeight : maxHeight}px`}"
  >
    <span v-html="withLink" />
    <span
      v-if="isLongText"
      class="cell-hide-show__button"
      :class="[isShow && 'cell-hide-show__button_hide']"
      @click="onChangeStatus"
    >
      {{ textButton }}
    </span>
  </div>
</template>

<script>
import {get} from 'lodash'

export default {
  name: 'CellHideShow',
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    column: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    isShow: false,
    isLongText: false,
    longHeight: 0,
    maxHeight: 79,
    withLink: null
  }),
  computed: {
    value () {
      const { prop } = this.column
      return get(this.row, prop, '')
    },
    textButton () {
      return this.isShow ? 'Hide less' : 'Show more'
    }
  },
  methods: {
    isOverflowed () {
      const element = this.$refs[`cell-hide-show_${this.row._id}`]
      if (!element) return
      const { scrollHeight } = element
      this.isLongText = scrollHeight > this.maxHeight
      this.longHeight = scrollHeight
      if (this.isLongText) {
        const element = document.getElementById(`bb-table-row_${this.row._id}`)
        element.style.alignItems = 'flex-start'
      }
    },
    onChangeStatus () {
      this.isShow = !this.isShow
    },
    setLinkColor () {
      // eslint-disable-next-line no-useless-escape
      const re = /([^\"=]{2}|^)((https?|ftp):\/\/\S+[^\s.,> )\];'\"!?])/
      const subst = '$1<a href="$2" class="cell-hide-show__link" target="_blank">$2</a>'
      this.withLink = this.value.replace(re, subst)
    }
  },
  mounted () {
    this.setLinkColor()
    this.$nextTick(() => {
      this.isOverflowed()
    })
  }
}
</script>

<style scoped lang="scss">
@import "../../../../sass/variables";

  .cell-hide-show {
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;

    &_center {
      max-height: 79px;
      height: auto !important;
    }

    &__button {
      position: absolute;
      top: 66px;
      right: 4px;
      padding: 0 0 0 10px;
      background: $color-white;
      color: $color-gray;
      cursor: pointer;

      &_hide {
        position: relative;
        top: 0;
        right: 0;
        padding: 0 0 0 5px;
      }
    }
  }
</style>

<style lang="scss">
@import "../../../../sass/variables";

  .cell-hide-show__link {
    color: $color-denim;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBTable/CellHideShow/CellHideShow.vue